import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          /* Base — token-based input border (--mui-input) and background
             (--mui-surface-sunken) ensure controls adapt across themes. */
          "flex h-9 w-full rounded-lg px-3 py-1 text-base md:text-sm",
          "border border-[hsl(var(--mui-input))] bg-[hsl(var(--mui-surface-sunken)/0.5)]",
          "shadow-sm transition-all duration-150",
          "file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground",
          "placeholder:text-muted-foreground",
          /* Focus ring uses --mui-focus token (teal accent). */
          "focus-visible:outline-none focus-visible:ring-2",
          "focus-visible:ring-[hsl(var(--mui-focus)/0.6)] focus-visible:border-[hsl(var(--mui-focus)/0.6)]",
          "hover:border-[hsl(var(--mui-focus)/0.4)]",
          /* Validation state — invalid inputs use --mui-danger border. */
          "aria-invalid:border-[hsl(var(--mui-danger))] aria-invalid:ring-0",
          "disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
